import { FeaturedTrialItemType } from '../Carousel/Carousel.types';

export type TrialCard = FeaturedTrialItemType;

/** Minimal study shape for filter-chip accessors (Featured Trial / studyList items). */
export interface StudyChipItem {
  id?: string;
  url?: string;
  fields?: {
    relatedTrial?:
      | string
      | null
      | {
          fields?: {
            featuredTrialCondition?: {
              fields?: {
                description?: { value?: string };
              };
            };
          };
        };
    trialCTA?: {
      value?: {
        href?: string;
      };
    };
  };
}

/** Minimal article shape for filter-chip accessors (matches ItemListing articleList items). */
export interface ArticleChipItem {
  id?: string;
  url?: string;
  fields?: {
    articleConditions?: {
      fields?: {
        description?: { value?: string };
      };
    };
  };
}

export type FilterChipsAlign = 'center' | 'start';

export interface FilterChipsProps<T> {
  items: T[];
  onFilterChange: (filteredItems: T[]) => void;
  getConditionLabel: (item: T) => string | null;
  getNavigateHref: (item: T) => string | undefined;
  allLabel?: string;
  align?: FilterChipsAlign;
  /** Optional override for single-result navigation (defaults to router.push). */
  onNavigate?: (href: string) => void;
}

export const ALL_STUDIES_LABEL = 'All Studies';
export const ALL_ARTICLES_LABEL = 'All Articles';
